import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AdminDashboard from "@/pages/admin/Dashboard";

/**
 * v1.25.8 — Smart landing for /admin.
 *
 * A Super User with NO active impersonation should never see MD Impex's home
 * dashboard by accident. They are routed to their own Super Dashboard where
 * they pick which tenant to enter. Regular Company Admins see the normal
 * AdminDashboard. Once a Super User has picked a company (impersonation set),
 * this route renders the AdminDashboard for that company just like any other
 * admin — until they hit "Exit to Super Dashboard".
 */
export default function AdminIndex() {
    const { user } = useAuth();
    const impersonating = typeof window !== "undefined" && !!localStorage.getItem("micm_impersonate_company");
    if (user?.is_super_user && !impersonating) {
        return <Navigate to="/admin/super/dashboard" replace />;
    }
    return <AdminDashboard />;
}
